import type { Build } from '@todesktop/shared';
import { Box, Text } from 'ink';
import Link from 'ink-link';

export default function BuildError({
  build,
  description = "Can't release",
  message,
}: {
  build: Build;
  description?: string;
  message: string;
}) {
  return (
    <Box flexDirection="column">
      <Text bold color="red">
        {description} {build.appName} v{build.appVersion}
      </Text>

      <Box marginBottom={1} marginTop={1}>
        <Text>{message}</Text>
      </Box>

      <Text bold>See web UI for more information: </Text>
      <Text>
        <Link fallback={false} url={build.url}>
          {build.url}
        </Link>
      </Text>
    </Box>
  );
}
